import Web3 from 'web3';
import {web3} from '../web3.js';

export const noteToAscii= {
    'A': 'a',
    'A#': 'A',
    'B': 'b',
    'C': 'c',
    'C#': 'C',
    'D': 'd',
    'D#': 'D',
    'E': 'e',
    'F': 'f',
    'F#': 'F',
    'G': 'g',
    'G#': 'G'
};

export const noteToBytes32 = {
    'A': web3.utils.asciiToHex('a'),
    'A#': web3.utils.asciiToHex('A'),
    'B': web3.utils.asciiToHex('b'),
    'C': web3.utils.asciiToHex('c'),
    'C#': web3.utils.asciiToHex('C'),
    'D': web3.utils.asciiToHex('d'),
    'D#': web3.utils.asciiToHex('D'),
    'E': web3.utils.asciiToHex('e'),
    'F': web3.utils.asciiToHex('f'),
    'F#': web3.utils.asciiToHex('F'),
    'G': web3.utils.asciiToHex('g'),
    'G#': web3.utils.asciiToHex('G')
};

let tmp = {};

for (let i in noteToBytes32) {
    tmp[noteToBytes32[i]] = i;
}

export const bytes32ToNote = tmp;
tmp = {};

for (let i in noteToAscii) {
    tmp[noteToAscii[i]] = i;
}


export const asciiToNote = tmp;
